"use client";
import { LoadingDots } from "./loading-dots";

export interface LoadingAnimationProps {
  colorScheme?: string;
}
export const LoadingAnimation = (props: LoadingAnimationProps) => (
  <LoadingDots color={`${props.colorScheme || "blue"}.500`} />
);

export default LoadingAnimation;
